<template>
    <div>

        <section class="feature-section section-odd">
            <div class="container">
              <h2 class="align-left"><i class="p1 fa fa-strong"></i> Powerful Simplicity</h2>


              <p>
                Skippr integration and data preparation tools automate away all the heavy lifting though simple pipeline configurations. View schemas, data throughput, latency and real-time sampling as data flows to your streaming services and cloud datalakes.
              </p>


              <div>
                <b-tabs content-class="mt-3" align="center">
                  <b-tab active v-on:click="clickEvent('ui')">
                    <template #title>
                      <i class="fa fa-laptop"></i> <strong>UI</strong>
                    </template>
                    <img src="images/homepage/powerful-simplicity.png" width="100%"/>
                  </b-tab>
                  <b-tab v-on:click="clickEvent('cli')">
                    <template #title>
                      <i class="fa fa-code"></i> <strong>CLI</strong>
                    </template>
                    <img src="images/homepage/cli-output-example.png" width="100%"/>
                  </b-tab>
                </b-tabs>
              </div>


            </div>
        </section>

    </div>
</template>

<script>


    export default {
        name: 'PipelinesUi',
        components: {
        },
        props: {
        },
        methods: {
          clickEvent(name) {
            this.$gtag.event('click', {
              event_category: 'flavour',
              event_label: name,
            })
          },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
